import { Link, generatePath } from 'react-router-dom';
import NotificationCard, { TYPES as NOTIFICATION_TYPES } from '../../messaging/notification-card';
import { Trans, useTranslation } from 'react-i18next';

import APP_ROUTES from '../../../constants/app-routes';
import { Button } from '@llt-frontend/react-material-button';
import ContentWithHeading from '../../../layouts/content-with-heading';
import { InteractionEventTrigger } from '@blueshift-ui/telemetry';
import React from 'react';
import useEssayNotifications from '../../../hooks/data-access/use-essay-notifications';

// Exports
// ------

export default function EssayStatusNotification() {
  const { t: translate, ready: translationsLoaded } = useTranslation(
    'study-support/async-essay/notification'
  );

  const notifications = useEssayNotifications();

  //
  // Render

  if (!(translationsLoaded && notifications.length)) {
    return null;
  }

  const multiple = notifications.length > 1;
  const [firstEssay] = notifications;

  const detailLink = multiple
    ? APP_ROUTES.essays
    : generatePath(APP_ROUTES.essayDetail, { essayId: firstEssay.request_uuid });

  return (
    <ContentWithHeading>
      <NotificationCard
        action={
          <InteractionEventTrigger
            analytics={{
              category: 'async-essays',
              action: multiple ? 'view-reviewed-essays' : 'view-reviewed-essay',
              label: 'notifications',
            }}
            element={Button}
            elementProps={{
              component: Link,
              contained: true,
              to: detailLink,
            }}
          >
            {translate(multiple ? 'viewAll' : 'view')}
          </InteractionEventTrigger>
        }
        type={NOTIFICATION_TYPES.success}
      >
        <Trans
          components={{
            bold: <b />,
          }}
          i18nKey={multiple ? 'reviewsComplete' : 'reviewComplete'}
          t={translate}
          values={{
            essayTitle: firstEssay.essay_title,
          }}
        />
      </NotificationCard>
    </ContentWithHeading>
  );
}
